import React from "react";
import styles from "../styles/AuthFooter.module.css";
import moment from "moment";
import { useSelector } from "react-redux";

export default function AuthFooter({ style = {} }) {
    const user = useSelector((state) => state.auth.user);

    return (
        <footer className={styles.footer} style={style}>
            <div className="d-flex align-items-center gap-4">
                <a href="https://applumi.io" className="tt-14 color-gray-07 " target="_blank" rel="noopener noreferrer">
                    © {moment().format("YYYY")} Lumi.
                </a>
            </div>

            <div className={styles.containerFooter}>
                <a className="tt-14 main-color-05" href="/termos-de-uso" target={user ? "_self" : "_blank"} rel="noopener noreferrer">
                    Termos de Uso e Políticas de Privacidade
                </a>
            </div>
        </footer>
    );
}
